package utils

import react.FC
import react.Props
import react.dom.html.ReactHTML.link
import react.dom.html.ReactHTML.meta
import react.dom.html.ReactHTML.script
import react.dom.html.ReactHTML.title
import react.useState
import web.cssom.HtmlAttributes.Companion.crossorigin

external interface HeaderProps : Props {
    var websiteUrl: String
    var websiteName: String
    var websiteTagLine: String
    var websiteDescription: String
    var newKeywordsMeta: Array<String>
    var websiteClassification: String
    var websiteEmail: String
    var websitePhone: String
    var websiteIcon: String
    var websiteCountryName: String
    var websiteRegion: String
}

val WebHeader = FC<HeaderProps> {
    val websiteUrl by useState(it.websiteUrl)
    val websiteName by useState(it.websiteName)
    val websiteTagLine by useState(it.websiteTagLine)
    val websiteDescription by useState(it.websiteDescription)
    val newKeywordsMeta by useState(it.newKeywordsMeta)
    val websiteClassification by useState(it.websiteClassification)
    val websiteEmail by useState(it.websiteEmail)
    val websitePhone by useState(it.websitePhone)
    val websiteIcon by useState(it.websiteIcon)
    val websiteCountryName by useState(it.websiteCountryName)
    val websiteRegion by useState(it.websiteRegion)
    script {
        async
        src = "https://www.googletagmanager.com/gtag/js?id=G-KNMVEH4V31"
    }
//    script {
//        +"""
//            window.dataLayer = window.dataLayer || [];
//            function gtag(){dataLayer.push(arguments);}
//            gtag('js', new Date());
//            gtag('config', 'G-KNMVEH4V31');
//        """.trimIndent()
//    }
    meta {
        charSet = "UTF-8"
    }
    title {
        +"$websiteName | $websiteTagLine"
    }

    meta {
        name = "viewport"
        content = "width=device-width, initial-scale=1.0"
    }
    meta {
        name = "robots"
        content = "max-image-preview:large"
    }
    link {
        rel = "canonical"
        href = websiteUrl
    }
    link {
        rel = "shortlink"
        href = websiteUrl
    }
    meta {
        name = "og:description"
        content = websiteDescription
    }
    meta {
        name = "description"
        content = websiteDescription
    }
    meta {
        name = "og:title"
        content = "$websiteName – $websiteTagLine"
    }
    meta {
        name = "title"
        content = "$websiteName – $websiteTagLine"
    }
    meta {
        name = "og:email"
        content = websiteEmail
    }
    meta {
        name = "email"
        content = websiteEmail
    }
    meta {
        name = "og:phone_number"
        content = websitePhone
    }
    meta {
        name = "url"
        content = websiteUrl
    }
    meta {
        name = "og:url"
        content = websiteUrl
    }
    meta {
        name = "identifier-URL"
        content = websiteUrl
    }
    meta {
        name = "Classification"
        content = websiteClassification
    }
    meta {
        name = "author"
        content = "ChApp Digital Systems, mawasiliano@chappds.com, https://chappds.com"
    }
    meta {
        name = "generator"
        content = "Kotlin Multiplatform, Kotlin ReactJS, TailwindCSS, Ktor"
    }
    meta {
        name = "og:region"
        content = websiteRegion
    }
    meta {
        name = "og:country-name"
        content = websiteCountryName
    }
    meta {
        name = "new_keywords"
        content = newKeywordsMeta.joinToString()
    }
    meta {
        name = "copyright"
        content = websiteName
    }
    meta {
        name = "language"
        content = "ES"

    }
//    meta {
//        name = "revised"
//        content = net
//    }
//    meta {
//        name = "last-modified"
//        content = com.sacred-worship.web.BuildInfo.REVISED
//    }
//    meta {
//        name = "og:updated_time"
//        content = com.sacred-worship.web.BuildInfo.REVISED
//    }
//    meta {
//        name = "app-last-update"
//        content = com.sacred-worship.web.BuildInfo.REVISED
//    }
//    meta {
//        name = "revised"
//        content = com.sacred-worship.web.BuildInfo.REVISED
//    }
    link {
        rel = "manifest"
        href = "/manifest.json"
    }
    meta {
        name = "mobile-web-app-capable"
        content = "yes"
    }
    meta {
        name = "apple-mobile-web-app-title"
        content = websiteName
    }
    meta {
        name = "apple-mobile-web-app-capable"
        content = "yes"
    }
    meta {
        name = "apple-touch-fullscreen"
        content = "yes"
    }
    link {
        rel = "icon"
        href = websiteIcon
        type = "image/png"
    }
    link {
        rel = "favicon"
        href = websiteIcon
        type = "image/png"
    }
    link {
        rel = "apple-touch-icon"
        href = websiteIcon
        type = "image/png"
    }
    link {
        rel = "apple-touch-startup-image"
        href = websiteIcon
        type = "image/png"
    }
//    link {
//        href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
//        rel = "stylesheet"
//        integrity = "sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH"
//        crossOrigin = CrossOrigin.anonymous
//    }
//    script {
//        src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"
//        integrity = "sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz"
//        crossOrigin = CrossOrigin.anonymous
//    }
    link {
        rel = "stylesheet"
        href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
    }
//    link { href = "assets/css/style.css"; rel = "stylesheet" }
//    link {
//        href="styles/tailwind.css"
//        rel="stylesheet"
//    }
    link {
        href="styles/generated.css"
        rel="stylesheet"
    }

    link {
        rel = "preconnect"
        href = "https://fonts.googleapis.com"
    }
    link {
        rel = "preconnect"
        href = "https://fonts.gstatic.com"
        crossorigin
    }
    link {
        href =
            "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel = "stylesheet"
    }
    meta {
        name="robots"
        content= "noindex, nofollow"
    }

}